import { FC, Fragment } from 'react';
import { useDisclosure } from '@chakra-ui/react';

import SunshineIconButton from 'components/_core/IconButton';
import SunshineDropdown from 'components/_core/SunshineDropdown';

import { MenuItem } from './types';

interface EditMenuProps {
  menuItems: MenuItem[];
  onClick?: () => void;
}

/**
 * Menu with invoice/quote/client edit actions
 * Used in list views
 */
const EditMenu: FC<EditMenuProps> = ({
  menuItems,
  onClick: onItemClick = () => {},
}) => {
  const {
    isOpen: isMenuOpen,
    onClose: closeMenu,
    onToggle: toggleMenu,
  } = useDisclosure();

  return (
    <SunshineDropdown isOpen={isMenuOpen} onClose={closeMenu}>
      <SunshineDropdown.Trigger
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          toggleMenu();
        }}
      >
        <SunshineIconButton
          aria-label="Actions"
          icon="vertical-ellipsis"
          variant="secondary"
        />
      </SunshineDropdown.Trigger>

      <SunshineDropdown.List>
        {menuItems.map(
          ({ colorScheme, hasBottomSeparator, icon, onClick, title }) => (
            <Fragment key={title}>
              <SunshineDropdown.Item
                as="div"
                colorScheme={colorScheme}
                icon={icon}
                key={title}
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  onItemClick();
                  onClick();
                }}
              >
                {title}
              </SunshineDropdown.Item>

              {hasBottomSeparator ? <SunshineDropdown.Divider /> : null}
            </Fragment>
          ),
        )}
      </SunshineDropdown.List>
    </SunshineDropdown>
  );
};
export default EditMenu;
